<template>
    <v-row justify="center">
        <v-col
            cols="12"
            md="10">
            <v-pagination
                v-model="page"
                :length="totalPages"
                :total-visible="7"
                @input="current"
                @next="next"
                @previous="prev">
            </v-pagination>
        </v-col>
        <v-col
            cols="12"
            md="1">
            <v-select
				hide-details="auto"
				outlined dense
                :items="pageSizes"
                v-model="CurrentPageSize">
            </v-select>
        </v-col>
    </v-row>
</template>

<script>
export default {
	name: 'Pagination',
	props: {
		currentPage: {
			type: Number,
		},
		totalPages: {
			type: Number,
		},
		pageSize: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			pageSizes: [
				{ text: '10', value: 10 },
				{ text: '25', value: 25 },
				{ text: '50', value: 50 },
			],
			page: this.currentPage || 1,
		};
	},
	computed: {
		CurrentPageSize: {
			get() {
				return this.pageSize;
			},
			set(value) {
				this.$emit('pageSizeChanged', value);
			},
		},
		CurrentPage() {
			return this.currentPage;
		},
	},
	methods: {
		current(newPage) {
			this.$emit('current', newPage);
		},
		next() {
			this.$emit('next');
		},
		prev() {
			this.$emit('prev');
		},
	},
	watch: {
		currentPage() {
			this.page = this.currentPage;
		},
	},
};
</script>
